// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#afbs-timer[data-v-6e663172]{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
